import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import LineRoomUpgradeIcon from 'components/Luxkit/Icons/line/LineRoomUpgradeIcon'
import Plural from 'components/utils/Formatters/Plural'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  gravity: 'south',
}

interface Props {
  image: App.Image
  tier: App.LoyaltyTier
  numberOfBenefitRemaining: number
}

function LandingPageLoyaltyHotelUpgradeBenefitsModal(props: Props) {
  const { image, tier, numberOfBenefitRemaining } = props
  return (
    <ModalBase size="L">
      <ModalHeader title="Free room upgrades" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            {!!numberOfBenefitRemaining && <LoyaltyTierCallOutBanner
              tier={tier}
              subtitle={<BodyText variant="small">{getLoyaltyTierDisplayName(tier)} Member Benefit</BodyText>}
              icon={<LineRoomUpgradeIcon />}
            >
              <BodyText variant="medium">You have {numberOfBenefitRemaining > 1 ? `${numberOfBenefitRemaining}x` : 'a'} free room <Plural count={numberOfBenefitRemaining} singular="upgrade" plural="upgrades" /> available</BodyText>
            </LoyaltyTierCallOutBanner>}
            <BodyText variant="large">
              Elevate your stay. Enjoy complimentary room upgrades at participating hotels—subject to availability—so you can travel in even more style.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                When browsing for a hotel, you will been shown which offers are eligible for a room upgrade. Once applied the room will automatically be upgraded at no additional cost.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyHotelUpgradeBenefitsModal
